import React from "react";
import { Route } from "react-router-dom";
import Public from "./Public";
import { Storage } from "../Storage/Storage";
import helperFunction from "../Function/helperFunction";
import { access } from "../Container/Subadmin/accessObj";

const startsWithCapital = ([...word]) => {
  let path = [];
  // eslint-disable-next-line
  word.map((char, key) => {
    if (/[A-Z]/.test(char)) {
      if (key > 0) {
        path.push("-");
        path.push(char.toLowerCase());
      } else {
        path.push(char.toLowerCase());
      }
    } else {
      path.push(char);
    }
  });
  return path.join("");
};

const startsWithCapitalfor_ = ([...word]) => {
  let path = [];
  // eslint-disable-next-line
  word.map((char, key) => {
    if (/[A-Z]/.test(char)) {
      if (key > 0) {
        path.push("_");
        path.push(char.toLowerCase());
      } else {
        path.push(char.toLowerCase());
      }
    } else {
      path.push(char);
    }
  });
  return path.join("");
};

export const getRedirectRoute = (route) => {
  let details = Storage.get("auth");
  let selRoutes = getkey(route);
  if (details.admin_type === "SUPERADMIN") {
    return "/dashboard";
  } else {
    return selRoutes[0].props.path;
  }
};

// const checkAccess = (val) => {
//     let details = Storage.get('auth')
//     let approve = false
//     if(details?.admin_type && details?.admin_type==="SUPERADMIN"){
//         approve = true
//     }else if(val.accessGroup==="all"){
//         approve = true
//     }else{
//         details?.access && helperFunction.accessArrayCreater(details.access,access).map((item)=> {
//             if(item.sub_item){
//                 item.sub_item.map((item1)=> {
//                     if(item1.sub_item){
//                         item1.sub_item.map((item2)=> {
//                             if(item1.value===val.accessGroup || item2.value===val.accessGroup){
//                                 approve = true
//                             }
//                         })
//                     }else if(item1.value===val.accessGroup){
//                         approve = true
//                     }
//                 })
//             }else if(item.value===val.accessGroup){
//                 approve = true
//             }
//         })
//     }
//     return approve
// }

const checkAccess = (val) => {
  let details = Storage.get("auth");
  // console.log(details,'details')
  let approve = false;
  let accessArr = val.accessGroup.split("|");
  if (
    accessArr.find((name) => {
      return name == "pick_up_scheduler";
    })
  ) {
  }
  if (details?.admin_type && details?.admin_type === "SUPERADMIN") {
    approve = true;
  } else if (
    accessArr.find((name) => {
      return name == "all";
    })
  ) {
    approve = true;
  } else {
    details?.access &&
      helperFunction.accessArrayCreater(details.access, access).map((item) => {
        if (item.sub_item) {
          item.sub_item.map((item1) => {
            if (item1.sub_item) {
              item1.sub_item.map((item2) => {
                if (
                    accessArr.find((name)=>{ return name == item1.value})||
                    accessArr.find((name)=>{ return name == item2.value})
                ) {
                  approve = true;
                }
              });
            } else if (
              accessArr.find((name) => {
                return name == item1.value;
              })
            ) {
              approve = true;
            }
          });
        } else if (
          accessArr.find((name) => {
            return name == item.value;
          })
        ) {
          approve = true;
        }
      });
  }
  return approve;
};

const getkey = (Pages) => {
  let arry = [];
  for (let i = 0; i < Pages.length; i++) {
    if (checkAccess(Pages[i])) {
      if (Pages[i].Name === "Dashboard") {
        arry.push(
          <Route
            key={Pages[i].Name}
            path={"/" + startsWithCapital(Pages[i].Name)}
            exact={true}
            component={Pages[i].Component}
          />
        );
      } else {
        arry.push(
          <Route
            key={Pages[i].Name}
            path={"/" + startsWithCapital(Pages[i].Name)}
            exact={true}
            component={Pages[i].Component}
          />
        );
      }
    }
  }
  // for (let key in Pages) {
  //     if (Object.hasOwnProperty.call(Pages, key)) {
  //         checkAccess(key)
  //         if (key === 'Dashboard') {
  //             arry.push(<Route key={key} path={'/' + startsWithCapital(key)} exact={true} component={Pages[key]} />)
  //         } else {
  //             arry.push(<Route key={key} path={'/' + startsWithCapital(key)} exact={true} component={Pages[key]} />)
  //         }
  //     }
  // }
  return arry;
};

export default function RouteFunction(Pages, isthis) {
  if (isthis) {
    return authRoute(Pages);
  } else {
    return getkey(Pages);
  }
}

const authRoute = (Pages) => {
  let arry = [];
  for (let key in Pages) {
    if (Object.hasOwnProperty.call(Pages, key)) {
      if (key === "ResetPassword") {
        arry.push(
          <Public
            key={key}
            path={"/" + startsWithCapitalfor_(key)}
            exact={false}
            component={Pages[key]}
          />
        );
      } else {
        arry.push(
          <Public
            key={key}
            path={"/" + startsWithCapital(key)}
            exact={true}
            component={Pages[key]}
          />
        );
      }
    }
  }
  return arry;
};
